//
// vendor modules
import React, { Component } from "react"
import { connect } from "react-redux"

// shared modules
import { updateFilter } from "shared/search/action-creators"

import {
    selectFilterValue,
    selectIsRegisteredFilter,
    selectIsPermanentFilter,
    selectIsFilterGroupOpen,
} from "shared/search/selectors"

// component modules
import Filter from "shared/search/components/Filter/index"

const actions = {
    updateFilter,
}

const mapStateToProps = (state, props) => ({
    value: selectFilterValue(state, props),
    isRegistered: selectIsRegisteredFilter(state, props),
    isPermanent: selectIsPermanentFilter(state, props),
    filterGroupIsOpen: selectIsFilterGroupOpen(state, props),
})

export default connect(mapStateToProps, actions)(Filter)
